import _ from 'lodash';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import { useFormContext } from 'react-hook-form';
import { MenuItem, Typography } from '@material-ui/core';
import FormSection from '../../form/FormSection';
import NgpSelect from '../../form/NgpSelect';
import { CRYPTO_CONF_MODULES_FIELD, CRYPTO_CONF_POLICY_FIELD, CRYPTO_POLICY_OPTIONS } from './AgentConstants';
import NgpTextField from '../../form/NgpTextField';

const cryptoPolicyLabel = i18n._(t`Cryptographic Policy`);
const extendingPolicyByModulesLabel = i18n._(t`Extending the Policy By Using Modules.`);

export function AgentDetailCryptoPolicy({ classes }) {
    const { watch } = useFormContext();
    const cryptoPolicy = watch(CRYPTO_CONF_POLICY_FIELD);
    const cryptoModules = watch(CRYPTO_CONF_MODULES_FIELD);

    return (
        <>
            <FormSection title={<Trans>Cryptographic Policy Configuration</Trans>}>
                <Typography variant="body2" style={{ marginTop: 16 }} bold italic>
                    {'Note: The nPoint will be rebooted if changing the policy!'}
                </Typography>
                <NgpSelect
                    label={cryptoPolicyLabel}
                    fieldName={CRYPTO_CONF_POLICY_FIELD}
                    className={classes.cryptoPolicy}
                    required
                >
                    {_.map(CRYPTO_POLICY_OPTIONS.getPairs(), (item) => (
                        <MenuItem key={item.key} value={item.key}>
                            {item.value}
                        </MenuItem>
                    ))}
                </NgpSelect>
                <NgpTextField
                    label={extendingPolicyByModulesLabel}
                    fieldName={CRYPTO_CONF_MODULES_FIELD}
                    className={classes.cryptoModules}
                    helpTipText="Module examples:SHA1, SHA1:ECDHE-ONLY. Colon separated if more than one. Frequently used modules: SHA1, NO-SHA1, ECDHE-ONLY and etc. The complete list is in /usr/share/crypto-policies/policies/modules on Edge Sensor."
                />
                <Typography variant="body2" style={{ marginTop: 16 }}>
                    {i18n._(t`The policy string is`)} {_.trim(_.compact([cryptoPolicy, cryptoModules]).join(':'))}
                </Typography>
            </FormSection>
        </>
    );
}
